// extracted by mini-css-extract-plugin
export default {"similarProducts":"SimilarProducts_similarProducts__C366J","title":"SimilarProducts_title__XE1RE"};